module.exports = __webpack_public_path__ + "static/media/img1-1.3da9b05e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/nutricheck_foliar/N/img1-1.png
// module id = 1186
// module chunks = 3